let vehicleSystemIdSeed = 0;

export const getNextVehicleSystemId = () => {
  vehicleSystemIdSeed += 1;
  return `VHC-TMP-${Date.now()}-${vehicleSystemIdSeed}`;
};

export const vehicleMakeOptions = [
  { label: "Toyota", value: "Toyota" },
  { label: "Ford", value: "Ford" },
  { label: "Isuzu", value: "Isuzu" },
  { label: "Mitsubishi", value: "Mitsubishi" },
  { label: "Nissan", value: "Nissan" },
  { label: "Chevrolet", value: "Chevrolet" },
  { label: "Hyundai", value: "Hyundai" },
  { label: "Honda", value: "Honda" },
];

export const vehicleModelOptions = [
  { label: "Hilux", value: "Hilux" },
  { label: "Ranger", value: "Ranger" },
  { label: "D-Max", value: "D-Max" },
  { label: "L200", value: "L200" },
  { label: "Navara", value: "Navara" },
  { label: "Colorado", value: "Colorado" },
  { label: "HL930I", value: "HL930I" },
  { label: "Ridgeline", value: "Ridgeline" },
];

export const fuelTypeOptions = [
  { label: "Petrol", value: "petrol" },
  { label: "Diesel", value: "diesel" },
  { label: "High Octane", value: "high_octane" },
  { label: "CNG", value: "cng" },
  { label: "LPG", value: "lpg" },
];

export const vehicleTypeOptions = [
  { label: "Truck", value: "truck" },
  { label: "Van", value: "van" },
  { label: "Car", value: "car" },
  { label: "Bus", value: "bus" },
];

export const odometerUnitOptions = [
  { label: "Kilometers", value: "km" },
  { label: "Miles", value: "miles" },
];

export const transmissionTypeOptions = [
  { label: "Manual", value: "manual" },
  { label: "Automatic", value: "automatic" },
  { label: "Semi Automatic", value: "semi_automatic" },
];

export const branchOptions = [
  { label: "Karachi", value: "Karachi" },
  { label: "Lahore", value: "Lahore" },
  { label: "Islamabad", value: "Islamabad" },
  { label: "Rawalpindi", value: "Rawalpindi" },
  { label: "Faisalabad", value: "Faisalabad" },
  { label: "Multan", value: "Multan" },
  { label: "Gujranwala", value: "Gujranwala" },
  { label: "Peshawar", value: "Peshawar" },
];

export const vehicleStatusOptions = [
  { label: "Active", value: "active" },
  { label: "Under Maintenance", value: "under_maintenance" },
  { label: "Inactive", value: "inactive" },
  { label: "Decommissioned", value: "decommissioned" },
];

export const paymentTypeOptions = [
  { label: "Full Payment", value: "full_payment" },
  { label: "Installments", value: "installments" },
];

export const paymentMethodOptions = [
  { label: "Bank Transfer", value: "bank_transfer" },
  { label: "Cash", value: "cash" },
  { label: "Lease", value: "lease" },
  { label: "Financing", value: "financing" },
];

export const trackingPackageOptions = [
  { label: "Standard", value: "standard" },
  { label: "Premium", value: "premium" },
];

export const vendorOptions = [
  { label: "AutoHub Motors", value: "AutoHub Motors" },
  { label: "Fleet Prime", value: "Fleet Prime" },
  { label: "RoadLine Traders", value: "RoadLine Traders" },
  { label: "National Vehicles", value: "National Vehicles" },
];

export const depreciationMethodOptions = [
  { label: "Straight Line", value: "straight_line" },
  { label: "Reducing Balance", value: "reducing_balance" },
];

export const installmentFrequencyOptions = [
  { label: "Monthly", value: "monthly" },
  { label: "Quarterly", value: "quarterly" },
];

export const insuranceProviderOptions = [
  { label: "Adamjee Insurance", value: "adamjee_insurance" },
  { label: "EFU General Insurance", value: "efu_general" },
  { label: "Jubilee General Insurance", value: "jubilee_general" },
  { label: "State Life Insurance", value: "state_life" },
  { label: "TPL Insurance", value: "tpl_insurance" },
  { label: "IGI Insurance", value: "igi_insurance" },
  { label: "Pak Qatar General Takaful", value: "pak_qatar_takaful" },
  { label: "Alfalah Insurance", value: "alfalah_insurance" },
  { label: "Askari General Insurance", value: "askari_general" },
  { label: "UBL Insurers", value: "ubl_insurers" },
];

export const coverageTypeOptions = [
  { label: "Comprehensive", value: "comprehensive" },
  { label: "Third Party", value: "third_party" },
];

export const contractTypeOptions = [
  { label: "Monthly Contract", value: "monthly_contract" },
  { label: "Per Trip Contract", value: "per_trip_contract" },
  { label: "Per Kilometer Contract", value: "per_kilometer_contract" },
  { label: "Daily Contract", value: "daily_contract" },
  { label: "Long Term Lease", value: "long_term_lease" },
];

export const billingFrequencyOptions = [
  { label: "Per Trip", value: "per_trip" },
  { label: "Daily", value: "daily" },
  { label: "Weekly", value: "weekly" },
  { label: "Monthly", value: "monthly" },
  { label: "Per Kilometer", value: "per_kilometer" },
];
